/**
 * Browser exceptions that are reported as errors but are not faults, shared by both error
 * trackers: PostHog's `before_send` (`dropBenignExceptions` in `./posthog.ts`) and Sentry's
 * `ignoreErrors` (`src/instrumentation-client.ts`). One list, so the two cannot disagree about what
 * counts as noise. Matched on the message, since neither error carries a useful stack.
 *
 * Add a pattern only with evidence that it is noise, and say what the evidence was.
 */
;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();export const BENIGN_EXCEPTIONS: RegExp[] = [
  /**
   * `ResizeObserver loop completed with undelivered notifications` (and its older spelling,
   * `ResizeObserver loop limit exceeded`) means a layout observer changed a size that was being
   * observed, so the browser delivered the rest of the notifications one frame later. The spec
   * defines it as a report, not a failure: nothing breaks and the page renders the same. Every
   * framework with a transition that measures itself — the register form's step changes here — can
   * trigger it. Sentry already drops it through its own inbound filter; PostHog did not.
   */
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/,
]
